import usePackageLimits from "@/hooks/usePackageLimits";
import {useCallback, useMemo} from "react";
import {useTranslation} from "react-i18next";

const usePriceFormat = ({fractionDigits}: {fractionDigits?: number} = {}) => {
  const {i18n} = useTranslation();
  const {currency} = usePackageLimits();
  const formatter = useMemo(
    () =>
      Intl.NumberFormat(i18n.language, {
        currency: currency,
        style: "currency",
        maximumFractionDigits: fractionDigits ?? 0,
      }),
    [i18n.language, currency, fractionDigits],
  );
  const format = useCallback((value: number | null | undefined) => formatter.format(value || 0), [formatter]);

  return format;
};

export {usePriceFormat};
